import { getRoute } from "../client"
import type { PomodoroCycleDto, StudyType } from "../../shared/types"
import type { AuthAccount } from "../auth"

export interface RestoredSession {
  profile: {
    userName: string
    userCity: string
    gender: "male" | "female"
    characterKey: string
    hairKey: string
    clothesKey: string
    skinColor: string
    hairColor: string
    clothesColor: string
    studyType: StudyType | null
    studyValue: string
  } | null
  coins: number
  activeRoomId: string | null
  account: AuthAccount | null
  pomodoro: PomodoroCycleDto | null
}

export const restoreSessionRoute = getRoute<RestoredSession>("/api/session/restore")
